import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-process-messages-section',
    templateUrl: './process-messages-section.component.html',
    styleUrls: ['./process-messages-section.component.scss']
})
export class ProcessMessagesSectionComponent implements OnInit {
    @Input()
    process: ITaskModel;

    constructor() {}

    ngOnInit(): void {}
}
